const Paths = {
  home: {
    cotations: "/cotations",
    customCotations: "/custom-cotations",
    customCotationsId: "/custom-cotations/:id",
    cotationsId: "/cotations/:id",
    pendingShipments: "/pending-shipments",
    updateQuotationManual: "/update-cotation/:id",
    updateQuotationOcr: "/update-cotation/ocr/:id",
    validatedShipments: "/validated-shipments",
    updateRequest: "/update-request/:id",
    profile: "/profile",
    invoices: "/invoices",
  },
  bo: {
    customQuotationsBox: "/admin/custom-quotations-box",
    packaging: "/admin/packaging",
    collection: "/admin/collection",
    collectionParamters: "/admin/collection-parameters",
    invoices: "/admin/invoices",
    parameters: "/admin/parameters",
    parametersCustoms: "/admin/parameters/customs",
    parametersTarifs: "/admin/parameters/tarifs",
    parametersOptions: "/admin/parameters/options",
    parametersUsers: "/admin/parameters/users",
    parametersRegister: "/admin/parameters/register",
    parametersLogs: "/admin/parameters/logs",
    clients: "/admin/clients",
    clientId: "/admin/clients/:id",
    customs: "/admin/customs",
    validatedExpeditionsV2: "/admin/finalized-expeditions-v2",
    deletedExpeditionsV2: "/admin/finalized-expeditions-v2/deleted",
    expeditionsBox: "/admin/expeditions-box",
    blockedExpeditionsV2: "/admin/blocked-expeditions-v2",
    expeditionsHistoryV2: "/admin/expeditions-history-v2",
    importer: "/admin/importers",
    products: "/admin/products",
    ratings: "/admin/tarifs",
    expeditionForm: "/admin/expedition/:id",
    customPolicy: "/admin/custom-policies/:customsId",
    logs: "/admin/logs",
  },
  auth: {
    register: "/register",
    login: "/login",
    forgotPassword: "/forgot-password",
    resetPasswordConfirmation: "/reset-password-confirmation",
    resetPassword: "/reset-password/:token",
    resetPasswordSuccess: "/reset-password-success",
  },
  others: {
    postpone: "/postpone/:id",
    tracking: "/tracking",
  },
};

export default Paths;
